/* Hand-drawn gold line sketches for the DBEST Method. */
const S = ({ children, size = 80, className = "" }) => (
  <svg viewBox="0 0 80 80" width={size} height={size} className={`sketch ${className}`} fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <g filter="url(#ink)">{children}</g>
  </svg>
);

export const InkFilter = () => (
  <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true">
    <filter id="ink"><feTurbulence type="fractalNoise" baseFrequency="0.045" numOctaves="2" seed="4" /><feDisplacementMap in="SourceGraphic" scale="1.8" /></filter>
  </svg>
);

const Decide = (p) => (
  <S {...p}>
    <path d="M40 15c-11 0-19.2 8.4-18.6 19 .4 7 4.2 11.4 7.8 15 2 2.1 2.9 4.6 3 7.5h15.6c.2-2.9 1.2-5.4 3.2-7.4 3.6-3.7 7.3-8.2 7.6-15.2C59 23.2 51 15 40 15z" />
    <path d="M32.8 61.3h14.8M33.6 66h13.2M36.2 70.6h8" />
    <path d="M34.6 45c1.7-3.2 3.6-3.1 5.3 0s3.7 3.1 5.4-.2" />
    <path d="M40 4.5v5.2M15 11.5l3.6 3.6M65.4 11.8l-3.5 3.4M6.5 33.5h5.2M68.6 34h5" />
  </S>
);

const Blueprint = (p) => (
  <S {...p}>
    <path d="M10 18.5l18-6.2 24 7 18-6.1v49.6l-18 6.2-24-7-18 6.1z" />
    <path d="M28 12.6v49.6M52 19.6v49.2" />
    <path d="M16 55c6-4.4 8.4-12.6 16-12.4 8.2.2 9.8 8.4 18 4.2 6.8-3.4 5.6-14 13.4-18.2" strokeDasharray="2.2 4.2" />
    <path d="M59.4 22.8l6.4 6.4M65.8 22.8l-6.4 6.4" />
    <circle cx="16" cy="55" r="1.8" />
  </S>
);

const Embody = (p) => (
  <S {...p}>
    <circle cx="40" cy="13.5" r="6.4" />
    <path d="M40 21c-.5 9 .4 18 0 27.2" />
    <path d="M40 28.6c-6.2-3-11-8.4-14.2-15.6M40 28.6c6.1-3.1 11-8.5 13.8-15.8" />
    <path d="M40 48.2c-3.2 7.8-5.2 15-7.6 23M40 48.2c3 7.9 4.8 15 7.3 23" />
    <path d="M23.6 73.4c10.4-1.5 22.2-1.3 32.8.3" />
    <path d="M63 36v8M59 40h8M15.6 44v6M12.6 47h6" />
  </S>
);

const Systemize = (p) => (
  <S {...p}>
    <path d="M13.6 16.5c0-3.5 11.8-6.1 26.4-6.1s26.4 2.6 26.4 6.1-11.8 6-26.4 6-26.4-2.5-26.4-6z" />
    <path d="M13.8 17c2.6 12 13 21 21.2 28.6V61M66.2 17c-2.6 12-13 21-21.2 28.6V65" />
    <path d="M45.2 65.4c10.4 6 24.4 1.6 26.6-12.4 1.4-9-1.8-16.8-5.8-21.6" />
    <path d="M61.6 33.6l4.6-3 1.6 5.2" />
    <path d="M28 28.5c3.8 1 8 1.4 12.2 1.4" strokeDasharray="1.5 3.5" />
  </S>
);

const Transmit = (p) => (
  <S {...p}>
    <path d="M40 34c-7.2-4.2-17-5.2-26-3.2v34.4c9-2 18.8-1 26 3.2M40 34c7.2-4.2 17-5.2 26-3.2v34.4c-9-2-18.8-1-26 3.2M40 34v34.4" />
    <path d="M20 41c5-.8 10.2-.2 14.4 1.6M20 48c5-.8 10.2-.2 14.4 1.6M45.6 42.6c4.2-1.8 9.4-2.4 14.4-1.6M45.6 49.6c4.2-1.8 9.4-2.4 14.4-1.6" />
    <path d="M40 7v11M22.4 11.6l5.2 7.4M57.8 11.4l-5.4 7.6M8.4 21.6l8.2 4.2M71.4 21.4l-8.2 4.4" />
  </S>
);

export const SKETCH = { Decide, Blueprint, Embody, Systemize, Transmit };
